import { isHeightConstrained } from '../../../../styles/mediaQueries'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      bodyWrap: {
        flex: '1 1 auto',
        overflowY: 'auto',

        [isHeightConstrained]: {
          flex: '1 0 auto',
        },
      },

      body: {
        ...tokens.fontBodyS,
        overflowY: 'hidden',
      },

      shadowTop: {
        opacity: 0,
      },

      shadowBottom: {
        opacity: 0,
      },
    },

    scrollShadow: {
      shadowTop: {
        borderColor: tokens.borderColorSubtle,
      },

      shadowBottom: {
        borderColor: tokens.borderColorSubtle,
      },
    },
  } as const
}
